var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-toolbarcustom',{attrs:{"app_title":"Quran","app_url":"sharia","app_icon":"clear"}}),_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-btn',{attrs:{"color":"success","block":"","round":""},on:{"click":_vm.OpenQuran}},[_vm._v("Klik untuk membaca Quran")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }